export default "__VITE_ASSET__DzzNh7Ho__"